import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage, {FORM_STATE_INIT_ERROR} from '../../components/plain/PlainPage';
import Label from '../../components/plain/Label';
import FieldString from '../../components/plain/FieldString';

import {FORM_USER_GROUP_PLAIN} from '../../util/consts/forms';
import { USER_PATH } from '../../util/routes';
import { performApiRequest, QUERY_GETPAGE_API_URL, } from '../../util/restapi';

class UserGroupPlainPage extends PlainPage {

	roles = [];

	constructor(props) {
		super(props);
		this.formPath = FORM_USER_GROUP_PLAIN;
		this.formTitle = 'Група користувачів';
		this.buildInstanceCard = this.buildGroupCard;
	}
	componentDidMount = async () => {
		document.title = 'BOM. ' + this.formTitle;
		let rolesRequest = {
			queryId : "role_table",
			page:1, pageSize: "2000",
			listColumn: [
				{ id: "role_id", visible:true, },
				{ id: "title", visible:true,},
				{ id: "description", visible:true,},
			],
			listPredicate:[], listHardFilter:[], 
			listSorting:[ { sortingId:"title", ascending:true } ]
		}
		let response = await performApiRequest(QUERY_GETPAGE_API_URL, rolesRequest);
		if( ! response.success ) {
			this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
			return;
		}
		for( let roleRow of response.data.data ) {
			this.roles.push( {
				roleId: roleRow.row[0].text, 
				roleTitle: roleRow.row[1].text, 
				roleDescription: roleRow.row[2].text 
			} );
		}
		this.init('UserGroup');
	}
	
	buildGroupCard = (groupInstance) => {
		let card = '';
		if( groupInstance.rootField.value.nick.value )
			card += groupInstance.rootField.value.nick.value + ': ';
		if( groupInstance.rootField.value.name.value )
			card += groupInstance.rootField.value.name.value;
		return card;
	}
	
	hasRole = (roleId) => {
		let instance = this.state.instance;
		let fieldListRole = instance.rootField.value.listRole;
		for(let role of fieldListRole.value) {
			if( role.value == roleId )
				return true;
		}
		return false;
	}
	setRole = (e, roleId) => {
		let checked = e.target.checked;
		let instance = this.state.instance;
		let fieldListRole = instance.rootField.value.listRole;
		
		if( checked ) {
			let item = instance.addListItem(fieldListRole);
			instance.setFieldValue(item, roleId)
		} else {
			for(let i=0; i < fieldListRole.value.length; i++) {
				if( fieldListRole.value[i].value == roleId ) {
					instance.deleteListItem(fieldListRole, i);
					break;
				}
			}
		}
		this.setState({instance: instance});
	}
	
	renderBody() {
		let instance = this.state.instance;
		
		let rolesHtml = this.roles.map( (role, index) => {
			
			return (
				<div key={index} style={{ display: 'flex',marginTop: '5px', }}>
					<input type='checkbox' checked={this.hasRole(role.roleId)} 
						onChange={ (e) => this.setRole(e, role.roleId)}
					/>
					<Label title={role.roleTitle + ' (' + role.roleId + ')'} tooltip={role.roleDescription}
						styles={{ wideTooltip: true, divMain: { marginLeft: '7px'} }}
					/>
				</div>
			);
		} );
		let usersHtml = this.instance.rootField.value.listUser.value.map( (fieldUser, index) => {
			let ref = fieldUser.value;
			let url = USER_PATH + '/' + ref.id;
			return (
				<div key={index} style={{ marginTop: '5px', }}>
					<a href={url}>{ref.card}</a>
				</div>
			);
		} );
		
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
						<FieldString instance={instance} path={'/nick'} plain={this}
							readOnly={this.instanceReadOnly} 
							styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/name'} plain={this}
							readOnly={this.instanceReadOnly} 
							styles={{ input: {flexGrow: '5'} }}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
						<FieldString instance={instance} path={'/comment'} plain={this}
							readOnly={this.instanceReadOnly} 
							styles={{ input: {flexGrow: '1', } }}
						/>
					</div>
					<div>
						{rolesHtml}
					</div>
					<div style={{marginTop: '15px'}}>
						<div>
							<Label title={'Користувачі групи'} tooltip={''} />
						</div>
						<div style={{paddingLeft: '20px'}}>
							{usersHtml}
						</div>
					</div>
				</div>
			</div>
		);
	}	
}

export default UserGroupPlainPage;